<template>
  <div class="product-content" v-loading="loading" :element-loading-text="loadingText">
    <div class="product-search">
      <el-form :model="searchData" inline size="small">
        <el-form-item label="搜索">
          <el-select v-model="searchData.type">
            <el-option :value="1" label="国内分销词"></el-option>
            <el-option :value="2" label="商品关键词"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="searchData.keywords"></el-input>
        </el-form-item>
        <el-form-item label="价格区间">
          <el-input-number :step="1" :precision="2" :min="0" v-model="searchData.priceStart"
                           controls-position="right"></el-input-number>
          -
          <el-input-number :step="1" :precision="2" :min="0" v-model="searchData.priceEnd"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="起批量">
          <el-input-number v-model="searchData.quantityBegin" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="idToProduct">ID查找商品</el-button>
        </el-form-item>
        <el-form-item v-if="!isBatchSupport">
          <el-button type="primary" @click="isBatchSupport=true">批量转为自营</el-button>
        </el-form-item>
        <el-form-item v-else>
          <el-button-group>
            <el-button type="primary" @click="selAll">全选</el-button>
            <el-button type="danger" @click="cancelSel">取选</el-button>
          </el-button-group>
          <el-button-group>
            <el-button type="success" @click="batchToSupport">转为自营</el-button>
            <el-button type="info" @click="cancelBatchToSupport">取消</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
      <alibaba-cates v-model="searchData.categoryIds"></alibaba-cates>
    </div>
    <div class="product-list-content">
      <div class="product-list">
        <template v-for="(item,index) in listData">
          <alibaba-product-item :is-batch-support="isBatchSupport" :item-data="item"
                                @select="selectItem($event,item,index)"></alibaba-product-item>
        </template>
      </div>
    </div>
    <div class="product-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[20, 30, 50]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.totalRecords">
      </el-pagination>
    </div>
    <alibaba-product-info ref="alibabaProductInfo"></alibaba-product-info>
    <support-products ref="supportProducts"></support-products>
  </div>

</template>
<script>
import index from "vuex";

import {timestampToTime} from "../../../utils/util";

import alibabaProductApi from "./api";
import AlibabaCates from "./components/alibabaCates.vue";
import AlibabaProductItem from "./components/alibabaProductItem.vue";
import AlibabaProductInfo from "./alibabaProductInfo.vue";
import SupportProducts from "./components/supportProducts.vue";

export default {
  components: {SupportProducts, AlibabaProductInfo, AlibabaProductItem, AlibabaCates},
  computed: {
    index() {
      return index
    }
  },
  watch: {
    'searchData.categoryIds': {
      handler(newVal, oldVal) {

        if (newVal != null) {
          this.searchData.pageNum = 1
          this.getList()
        }
      }
    }
  },
  data() {
    return {
      isBatchSupport: false,
      cateProps: {
        label: 'name',
        value: 'id',
        children: 'childLevel'
      },
      alibabaCateOne: [],
      alibabaCateTow: [],
      alibabaCateThree: [],
      categoriesData: [],
      categoriesDataOne: [],
      categoriesDataTwo: [],
      loading: false,
      loadingText: "阿里巴巴数据加载中",
      searchData: {
        type: 2,
        keywords: "",
        categoryIds: [],
        filter: [],
        priceEnd: 0,
        priceStart: 0,
        quantityBegin: 1,
        pageNum: 1,
        pageSize: 20,
      },
      relationOfferIds: [],
      cateDialogVisible: false,
      dialogVisible: false,
      productAttribute: [],

      ruleForm: {
        //店铺分类
        one: '',
        two: '',
        //商品分离
        business_category_id: ""
      },
      rules: {
        business_category_id: [
          {
            required: true,
            message: '请选择分类',
            trigger: ['change', 'blur']
          }
        ],
        one: [
          {
            required: true,
            message: '请选择店铺一级分类',
            trigger: ['change', 'blur']
          }
        ],
        two: [
          {
            required: true,
            message: '请选择店铺二级分类',
            trigger: ['change', 'blur']
          }
        ],
      },
      filters: [
        [],
        [

          {value: 'shipIn48Hours', label: "48小时发货"},
          {value: 'freeExchange7days', label: "7天包换"},
          {value: 'powerMerchant', label: "实力商家"},
          {value: 'crossPotential', label: "跨境潜力商品"},
          {value: 'ttpft', label: "批发团商品"},
          {value: 'jxhy', label: "精选货源商品"},
        ],
        [
          {value: '454658', label: "选品中心小二的严选优质品"},
          {value: '454466', label: "线下选品中心陈列品"},
        ]
      ],
      listData: [],
      repetitionNum:0,  //获取列表失败重新获取
      repetitionMaxNum:5,//失败后最大重试次数
      categoryData: [],
      supportList: new Map,
      pageInfo: {
        "totalPage": 0,
        "currentPage": 1,
        "pageSize": 20,
        "totalRecords": 0
      }
    }
  },
  mounted() {

  },
  methods: {
    cancelBatchToSupport() {
      this.cancelSel()
      this.isBatchSupport = false
    },
    selAll() {
      this.listData.forEach(item => {
        item.select = true
      })
    },
    cancelSel() {
      this.listData.forEach(item => {
        item.select = false

      })
    },
    timestampToTime,
    batchToSupport() {
      let selIds = [];
      let selTitleList = new Map();
      this.listData.forEach(item => {
        if (item.select) {
          selTitleList.set(item.offerId, {
            "id": item.offerId,
            "title": item.subject,
            "status": "",
          })
        }
      })
      this.$refs.supportProducts.open(selTitleList)

    },
    selectItem(e, item, index) {
      item.select = e;
    },
    idToProduct() {
      this.$prompt('阿里巴巴商品ID', '阿里巴巴商品ID搜索', {

        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        this.$refs.alibabaProductInfo.open(value)
      });
    },
    resetForm(formName) {
      this.cateDialogVisible = false;
    },

    search() {
      this.pageInfo.currentPage = 1;
      this.pageInfo.totalRecords = 0
      this.pageInfo.totalPage = 0
      this.getList()
    },
    getList() {
      this.listData = []
      this.relationOfferIds = []

      let data = JSON.parse(JSON.stringify(this.searchData))
      if (data.categoryIds.length > 0) {
        data.categoryIds = data.categoryIds.splice(data.categoryIds.length - 1)
      } else {
        data.categoryIds = []
      }

      this.loading = true
      this.loadingText = "阿里巴巴数据加载中";

     // let repetitionNum = 0;
      alibabaProductApi.list(data).then((res) => {
        if (res.status == 200) {
          let data = res.data
          if (data.success) {
            if (data.pageInfo) {
              this.pageInfo.totalPage = data.pageInfo.totalPage
              this.pageInfo.totalRecords = data.pageInfo.totalRecords
              this.pageInfo.currentPage = data.pageInfo.currentPage
              this.pageInfo.pageSize = data.pageInfo.pageSize
              this.listData = data.data.map((item, index) => {
                item["select"] = false;
                return item
              })
              this.relationOfferIds = data.relationOfferIds
            }else{
              if(this.repetitionNum<=this.repetitionMaxNum){
                this.repetitionNum++
                this.getList()
              }else{
                this.repetitionNum=0;
                this.$message.error("阿里巴巴列表获取失败！请刷新页面重试！");
              }
            }
          } else {

          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {

      this.searchData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {

      this.searchData.pageNum = val;
      this.getList();
    },


  }
}
</script>
<style scoped>
.product-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}

.product-search, .product-pagination {
  flex: 0;
}

.product-list-content {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
}

.product-list {

  display: flex;
  flex-wrap: wrap;
}

.product-pagination {
  margin-top: 10px;
}


</style>



// WEBPACK FOOTER //
// src/views/alibaba/product/alibabaProductList.vue